import z from 'zod';

import {
  BuyAndGetEarningMechanismSchema,
  BuyAndGetFormSchema,
  DraftPromotionSchema,
  FuelRollbackEarningMechanismSchema,
  FuelRollbackFormSchema,
  ProductDiscountEarningMechanismSchema,
  ProductDiscountFormSchema,
  TransactionDiscountEarningMechanismSchema,
  TransactionDiscountFormSchema,
  VarietyDiscountEarningMechanismSchema,
  VarietyDiscountFormSchema,
} from './schemas';

export enum PromotionType {
  ProductDiscount = 'productDiscount',
  TransactionDiscount = 'transactionDiscount',
  VarietyDiscount = 'varietyDiscount',
  BuyAndGet = 'buyAndGet',
  FuelRollback = 'fuelRollback',
}

export enum TransactionDiscountAwardType {
  PercentDiscount = 'percentDiscount',
  MoneyDiscount = 'moneyDiscount',
}

export enum ProductDiscountAwardType {
  Free = 'free',
  Discount = 'discount',
  PriceOverride = 'priceOverride',
}

export enum VarietyDiscountAwardType {
  TransactionDiscount = 'transactionDiscount',
  ProductDiscount = 'productDiscount',
  PriceOverride = 'priceOverride',
}

export type TransactionDiscountFormValues = z.infer<
  typeof TransactionDiscountEarningMechanismSchema
>;
export type FuelRollbackFormValues = z.infer<typeof FuelRollbackEarningMechanismSchema>;
export type ProductDiscountFormValues = z.infer<typeof ProductDiscountEarningMechanismSchema>;
export type BuyAndGetFormValues = z.infer<typeof BuyAndGetEarningMechanismSchema>;
export type VarietyDiscountFormValues = z.infer<typeof VarietyDiscountEarningMechanismSchema>;

export type PromotionConfigureFormValues =
  | z.infer<typeof DraftPromotionSchema>
  | z.infer<typeof TransactionDiscountFormSchema>
  | z.infer<typeof FuelRollbackFormSchema>
  | z.infer<typeof ProductDiscountFormSchema>
  | z.infer<typeof BuyAndGetFormSchema>
  | z.infer<typeof VarietyDiscountFormSchema>;

export type PromotionConfigureFormInitialValues = Partial<PromotionConfigureFormValues>;
